import React, { useState } from 'react';
import {
    makeStyles,
    Grid,
    Typography,
    Button,
    Dialog,
    DialogContent,
    Select,
    MenuItem
} from '@material-ui/core';


const MassChangePartnerDialog = (props) => {

    const useStyles = makeStyles((theme) => ({
        createUserButton: {
            width: 165,
            fontSize: 16,
            fontWeight: 600,
            backgroundColor: '#af001e',
            color: 'white',
            borderRadius: 0,
            '&:hover': {
                backgroundColor: '#af001eA5',
            }
        },
        dialogZ: {
            zIndex: 3000
        }
    }));

    const classes = useStyles();
    const [partnerIds, setPartnerIds] = useState([]);
    const {
        partners,
        massPartnerDialog,
        handleToggleMassPartnerDialog,
        changePartnerSelectedUsers
    } = props;

    return (
        <Dialog
            PaperProps={{
                style: {
                    borderRadius: 0,
                    padding: 20
                }
            }}
            maxWidth="xs"
            open={massPartnerDialog}
            onClose={handleToggleMassPartnerDialog}
            disableBackdropClick
            keepMounted>
            <DialogContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Typography style={{ color: '#3e3f60', fontSize: 30, fontWeight: 600 }}>Change Users Partner</Typography>
                    </Grid>
                    <Grid item>
                        <Grid container direction="column">
                            <Grid item>
                                <Typography>Select Partner</Typography>
                            </Grid>
                            <Grid item>
                                <Select
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    multiple
                                    value={partnerIds}
                                    onChange={(e) => {
                                        setPartnerIds(e.target.value)
                                    }}
                                    style={{
                                        borderRadius: 0,
                                        borderColor: '#c6c9db'
                                    }}>
                                    {
                                        partners && partners.length > 0 && partners.map((partner, key) => (
                                            <MenuItem key={key} value={partner.id}>{partner.name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction="row" alignItems="flex-start">
                            <Grid item>
                                <Button fullWidth size="large" className={classes.createUserButton} onClick={() => {
                                    changePartnerSelectedUsers(partnerIds);
                                    setPartnerIds([]);
                                }} color="primary">
                                    Update
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button fullWidth style={{ color: '#3e3f60', fontSize: 16, fontWeight: 600, width: 168 }} size="large" onClick={() => {
                                    setPartnerIds([]);
                                    handleToggleMassPartnerDialog();
                                }} color="primary">
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default MassChangePartnerDialog;
